import axios from 'axios';
import WebApiClient from './web';
import { uuid } from 'uuidv4';

let _apiClient = null;
let _webFallbackSessionId = null;
export function getApiClient() {
  // We must ensure that a UUID is created and
  if (_webFallbackSessionId == null) {
    _webFallbackSessionId = uuid();
    axios.defaults.headers.common['X-Lem-FallbackWebSessionID'] = _webFallbackSessionId;
  }
  if (_apiClient === null) {
    _apiClient = new WebApiClient();
  }
  return _apiClient;
}

// This is useful for tests.
export function injectApiClient(client) {
  _apiClient = client;
}

export function makeCancelTokenSource() {
  return axios.CancelToken.source();
}

export function isErrorCancel(error) {
  return axios.isCancel(error);
}

// This function MUST guarantee that it will call displayErrorFn exactly once.
export function handleApiError(error, displayErrorFn, kickUserOut = null, showRawMessage = false) {
  if (isErrorCancel(error)) {
    console.log(error.message);
    displayErrorFn(null);
  } else if (error.response) {
    if (error.response.status === 400) {
      displayErrorFn(
        showRawMessage
          ? error.response.data.message
          : 'Bad Request (400): ' + error.response.data.message
      );
    } else if (error.response.status === 401) {
      displayErrorFn('Error (401): ' + error.response.data.message);
      if (kickUserOut) kickUserOut();
    } else if (error.response.status === 403) {
      displayErrorFn('Forbidden (403): ' + error.response.data.message);
    } else if (error.response.status === 404) {
      displayErrorFn('Not Found (404)' + error.response.data.message);
    } else if (error.response.status === 405) {
      displayErrorFn('Method Not Allowed (405): This endpoint does not exist.');
    } else if (error.response.status === 409) {
      displayErrorFn(error.response.data.message);
    } else if (error.response.status === 413) {
      displayErrorFn('File Too Big (413): The upload limit is around 16MB.');
    } else if (error.response.status === 429) {
      // We hit the rate limits.
      displayErrorFn(
        'Too Many Requests (429): Please wait and try again, this operation is being done too frequently.');
    } else {
      displayErrorFn('Something went wrong on our end.');
    }
  } else if (error.request) {
    displayErrorFn('Please check your connection and try again.');
  } else {
    displayErrorFn('Error: ' + error.message);
  }
}

export function handleApiErrorButReturnMessage(error, kickUserOut = null) {
  let message = null;
  handleApiError(error, msg => { message = msg; }, kickUserOut);
  return message;
}

export function makeStandardApiErrorHandler(displayErrorFn, kickUserOut = null, showRawMessage = false) {
  return error => handleApiError(error, displayErrorFn, kickUserOut, showRawMessage);
}
